module.exports = __webpack_public_path__ + "static/media/sAuJeJzSKbUmHfBQRzmZ.9a723c40.svg";